import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { TimeBoundAvailabilityData } from "../../../utils/types";
import { fetchItemStatusRedux } from "../http/itemStatusFetch";

export type ItemStatusSliceType = {
  outOfStockItemsIds: number[];
  disabledItemsIds: number[];
  disabledItemsPerOrderType: {
    TAKE_OUT: number[];
    DINE_IN: number[];
    DELIVERY: number[];
    DELIVERYV2: number[];
  };
  itemsWithCustomDeliveryTimes: {
    [itemId: string]: number;
  };
  offersItems: any[];
  selectedItemTimeBoundData?: TimeBoundAvailabilityData;
};

const initialState: ItemStatusSliceType = {
  outOfStockItemsIds: [],
  disabledItemsIds: [],
  disabledItemsPerOrderType: {
    TAKE_OUT: [],
    DINE_IN: [],
    DELIVERY: [],
    DELIVERYV2: [],
  },
  itemsWithCustomDeliveryTimes: {},
  offersItems: [],
  selectedItemTimeBoundData: undefined,
};

export const itemStatusSliceType = createSlice({
  name: "itemStatusSliceType",
  initialState,
  reducers: {
    setSelectedItemTimeBoundData: (state, { payload }) => {
      state.selectedItemTimeBoundData = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchItemStatusRedux.fulfilled,
      (
        state,
        {
          payload,
        }: PayloadAction<{
          outOfStockItemsIds?: number[];
          disabledItemsIds?: number[];
          disabledItemsPerOrderType?: {
            TAKE_OUT: number[];
            DINE_IN: number[];
            DELIVERY: number[];
            DELIVERYV2: number[];
          };
          itemsWithCustomDeliveryTimes?: {
            [itemId: string]: number;
          };
          offersItems?: any;
        }>
      ) => {
        state.outOfStockItemsIds = payload.outOfStockItemsIds || [];
        state.disabledItemsIds = payload.disabledItemsIds || [];
        state.disabledItemsPerOrderType = payload.disabledItemsPerOrderType || {
          TAKE_OUT: [],
          DINE_IN: [],
          DELIVERY: [],
          DELIVERYV2: [],
        };
        state.itemsWithCustomDeliveryTimes =
          payload.itemsWithCustomDeliveryTimes || {};
        state.offersItems = payload.offersItems || [];
      }
    );
  },
});

export const { setSelectedItemTimeBoundData } = itemStatusSliceType.actions;

export default itemStatusSliceType.reducer;
